import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentSetupComponent } from '../my-account/payment-setup/payment-setup.component';
import { DonationComponent } from '../my-carts/check-out/donation/donation.component';
import { EndUserComponent } from '../my-carts/check-out/end-user/end-user.component';
import { SelectEndUserComponent } from '../my-carts/check-out/end-user/select-end-user/select-end-user.component';
import { OrderConfirmationComponent } from '../my-carts/check-out/order-confirmation/order-confirmation.component';
import { PaymentComponent } from '../my-carts/check-out/payment/payment.component';
import { SelectLocationComponent } from '../my-carts/check-out/shipping-address/select-location/select-location.component';
import { ShippingAddressComponent } from '../my-carts/check-out/shipping-address/shipping-address.component';
import { SummaryOrderComponent } from '../my-carts/check-out/summary-order/summary-order.component';
import { TenantComponent } from '../my-carts/check-out/tenant/tenant.component';
import { ManageMonthComponent } from './manage-month/manage-month.component';
import { ManageRenewalsDetails } from './manage-renewals-details/manage-renewals-details.component';
import { ManageRenewalsPortal } from './manage-renewals-portal.component';
import { ManageLtedetailsComponent } from './manage-upcoming-opportunity/manage-ltedetails/manage-ltedetails.component';
import { ManageRenewalsAnnuitiesComponent } from './manage-upcoming-opportunity/manage-renewals-annuities/manage-renewals-annuities.component';
import { ManageRenewlasSearchComponent } from './manage-upcoming-opportunity/manage-renewlas-search/manage-renewlas-search.component';
import { ManageUpcomingOpportunityComponent } from './manage-upcoming-opportunity/manage-upcoming-opportunity.component';
import { RenewalsCheckoutComponent } from './renewlas-checkout/renewals-checkout.component';

const routes: Routes = [
    {
        path: 'manageRenewalsNew',
        component: ManageRenewalsPortal,
        data: {
            breadcrumb: 'Renewals-new'
        },
        children: [
            {
                path: 'renewalsEndUser/upComing',
                component: ManageUpcomingOpportunityComponent,
                data: {
                  breadcrumb: 'Upcoming Opportunities'
                },
                children: [
                  {
                    path: ':renewalProgramName/:csn',
                    component: ManageRenewalsAnnuitiesComponent,
                    data: {
                      breadcrumb: 'renewalProgramName'
                    },
                    children: [
                      {
                        path: 'LTEDetails/:opportunityId',
                        component: ManageLtedetailsComponent,
                        data: {
                          breadcrumb: 'opportunityName',
                        }
                      },
                    ]
                  },
                  {
                    path: ':renewalProgramName/:csn/search/:searchOppId',
                    component: ManageRenewlasSearchComponent,
                    data: {
                      breadcrumb: 'searchOppId'
                    },
                    children: [
                      {
                        path: 'LTEDetails/:opportunityId',
                        component: ManageLtedetailsComponent,
                        data: {
                          breadcrumb: 'opportunityId',
                        }
                      }
                    ]
                  }
                ]
              },
            {
                path: 'month/:month',
                component: ManageMonthComponent,
                data: {
                    breadcrumb: 'Renewals-new'
                },
                children: [
                    {
                        path: 'renewalDetails/:serial',
                        component: ManageRenewalsDetails,
                        data: {
                            breadcrumb: 'Renewal-details'
                        },
                        children: [
                            {
                                path: 'checkout/:id/:cartName',
                                component: RenewalsCheckoutComponent,
                                data: {
                                    breadcrumb: 'Renewal-checkout'
                                },
                                children: [
                                    {
                                        path: 'select-location',
                                        component: SelectLocationComponent,
                                        data: {
                                            breadcrumb: 'Select Location',
                                        },
                                    },
                                    {
                                        path: 'tenant',
                                        component: TenantComponent,
                                        data: {
                                            breadcrumb: 'Tenant Information',
                                        }
                                    },
                                    {
                                        path: 'end-user',
                                        component: EndUserComponent,
                                        data: {
                                            breadcrumb: 'End User Information',
                                        }
                                    },
                                    {
                                        path: 'selectenduser',
                                        component: SelectEndUserComponent,
                                        data: {
                                            breadcrumb: 'Select End User',
                                        }
                                    },
                                    {
                                        path: 'payment-method',
                                        component: PaymentComponent,
                                        data: {
                                            breadcrumb: 'Payment',
                                        },
                                    },
                                    {
                                        path: 'donation',
                                        component: DonationComponent,
                                        data: {
                                            breadcrumb: 'Donation',
                                        },
                                    },
                                    {
                                        path: 'ship-address',
                                        component: ShippingAddressComponent,
                                        data: {
                                            breadcrumb: 'Ship Address',
                                        },
                                        children: [
                                            {
                                                path: 'select-location',
                                                component: SelectLocationComponent,
                                                data: {
                                                    breadcrumb: 'Select Location',
                                                },
                                            },
                                        ]
                                    },
                                    {
                                        path: 'summary-order',
                                        component: SummaryOrderComponent,
                                        data: {
                                            breadcrumb: 'Summary & Order',
                                        },
                                    },
                                    {
                                        path: 'order-confirmation',
                                        component: OrderConfirmationComponent
                                    },
                                    {
                                        path: 'digitalwallet',
                                        component: PaymentSetupComponent,
                                        data: {
                                            breadcrumb: 'Digital Wallet',
                                        },
                                    },
                                ]
                            },

                        ]
                    }
                ]
            }
        ]
    },
    {
        path: 'renewals',
        redirectTo: '/manageRenewalsNew',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ManageRenewalsPortalRoutingModule { }
